module.exports = __webpack_public_path__ + "static/media/img_howto_image@3x.8d07a28f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@3x/img_howto_image@3x.png
// module id = 1084
// module chunks = 0